import { makeStyles } from "@material-ui/core/styles";
import { secondary } from "../../../../../../assets/variables.module.scss";

const useStyles = makeStyles(() => ({
  chartContainer: {
    minHeight: 200,
  },
  spinner: {
    color: secondary,
  },
}));

export default useStyles;
